// Author Liu Cui Cui
// Date 2023-07-06 16:22:17

import * as model from "@/model/sithMes/mst/SithMesMstMaterialDrawingModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.SithMesMstMaterialDrawing(), newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_SITHMES_MST_URL,
    })
    .buildStore()
